import { getApiDetail, getApiErrorMessage } from '@/utils/apiErrors';

const BACKUP_CONFLICT_MESSAGE =
  'This user is currently covering another out-of-office responder. Replace them as backup before setting them out of office.';

export const getOutOfOfficeSaveErrorMessage = (
  error: unknown,
  fallback = 'Could not save out-of-office settings',
): string => {
  const detail = getApiDetail(error);
  if (!detail) return getApiErrorMessage(error, fallback);

  // Mirrors the backend's OOOValidationError repr (apps/users/exceptions.py).
  // If the format changes, the raw detail is shown as a fallback.
  const cleaned =
    detail.match(/OOOValidationError<\d+>:\s*message=(.*?)(?:,\s*data=.*)?$/)?.[1]?.trim() ??
    detail;
  return cleaned.includes('currently covering another OOO') ? BACKUP_CONFLICT_MESSAGE : cleaned;
};
